export function trimStringValues<T extends object>(valueToTrim: T) {
    let trimmedStrings = {} as { [key in keyof T]: string };
    Object.keys(valueToTrim).forEach(key => {
        const objectKey = key as keyof T;
        if (typeof valueToTrim[objectKey] === 'string') {
            trimmedStrings[objectKey] = (valueToTrim[objectKey] as unknown as string).trim();
        }
    });
    return trimmedStrings;
}